export const publicPagePaths = ['', 'terms', 'privacy', 'responsible-gambling'] as const;
export type PublicPagePath = (typeof publicPagePaths)[number];
